module.exports = __webpack_public_path__ + "media/images/expedientes-78df328376f47c17e588fb0b7fa1b485.svg";